import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { uticaConfig } from "./data";

export default function UticaPage() {
  return <CityPageTemplate config={uticaConfig} />;
}